<div
  data-testid="login-finnair-plus-card"
  class="flex flex--column border rounded-large white-bg surface-primary ms-medium-b overflow-hidden"
>
  <div class="flex flex--space-between ps-medium">
    <h3 class="mr-clear-t font-title-medium">{{ title | finLocalization }}</h3>
    @if (showIcon) {
      <fcom-icon [dataTestId]="'pax-logic-icon'" [name]="SvgLibraryIcon.FINNAIR_EMBLEM_BLOCK" />
    }
  </div>
  <div data-testid="pax-login-benefits" class="flex ps-medium-x ps-xsmall-y pax-login-row">
    @if (benefitMode === 'list') {
      <ul class="flex-1 pax-login-list mr-medium-r">
        @for (benefit of localizedBenefits(); track $index) {
          <li>{{ benefit }}</li>
        }
      </ul>
    } @else if (benefitMode === 'text') {
      <p class="pax-login-benefit-text regular-type ms-medium-r">
        {{ benefitText | finLocalization }}
      </p>
    }
    <div class="flex flex-1 flex--column">
      <fcom-button
        (clickBtn)="onLoginClick()"
        [theme]="ButtonTheme.SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL"
        [text]="'loginPromotion.loginButtonText' | finLocalization"
        data-testid="pax-login-card-log-in-button"
      />
      <fcom-button
        (clickBtn)="showForgotPassword ? onForgotPasswordClick() : onJoinClick()"
        [theme]="ButtonTheme.TERTIARY_GHOST"
        [mode]="ButtonMode.FILL"
        [text]="
          (showForgotPassword ? 'loginPromotion.forgotPassword' : 'loginPromotion.createAccount') | finLocalization
        "
        class="underline ms-xsmall-t"
        data-testid="pax-login-card-secondary-button"
      />
    </div>
  </div>
  @if (footnoteText) {
    <span
      data-testid="pax-login-footnote"
      class="grey-100-bg surface-secondary rounded-bottom-large ps-medium-x ps-xsmall-y regular-type font-body-medium"
      >{{ footnoteText | finLocalization }}
    </span>
  }
</div>
